import type { PlanSelectFragment } from '~/modules/pricing/graphql/fragments/plan.generated';
import type { IPlanConditions } from './plan-condition';

export enum IPlanKey {
  /**
   * @deprecated This plan is available for users installed before release 1.3.0.
   */
  CONTENT_TESTING = 'content-testing',
  PAGE_OPT = 'page-optimize',
  FUNNEL_OPT = 'funnel-optimize',
  PROFIT_OPT = 'profit-optimize',
  // Trial plans
  TRIAL_PAGE_OPT = 'trial-page-optimize',
  TRIAL_FUNNEL_OPT = 'trial-funnel-optimize',
  TRIAL_PROFIT_OPT = 'trial-profit-optimize',
}

export enum IPlatformPlanSource {
  PLATFORM_SUBSCRIPTION = 'PLATFORM_SUBSCRIPTION',
  DEV_TRANSFER = 'DEV_TRANSFER',
  INSTALL = 'INSTALL',
  MANUAL = 'MANUAL',
}

export interface IPlan extends PlanSelectFragment {
  planKey: IPlanKey;
  conditions?: IPlanConditions;
}
